(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-category-type', {
            parent: 'entity',
            url: '/event-category-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventCategoryType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-category-type/event-category-types.html',
                    controller: 'EventCategoryTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventCategoryType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-category-type-detail', {
            parent: 'entity',
            url: '/event-category-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventCategoryType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-category-type/event-category-type-detail.html',
                    controller: 'EventCategoryTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventCategoryType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventCategoryType', function($stateParams, EventCategoryType) {
                    return EventCategoryType.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-category-type.new', {
            parent: 'event-category-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-category-type/event-category-type-dialog.html',
                    controller: 'EventCategoryTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-category-type', null, { reload: true });
                }, function() {
                    $state.go('event-category-type');
                });
            }]
        })
        .state('event-category-type.edit', {
            parent: 'event-category-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-category-type/event-category-type-dialog.html',
                    controller: 'EventCategoryTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventCategoryType', function(EventCategoryType) {
                            return EventCategoryType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-category-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-category-type.delete', {
            parent: 'event-category-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-category-type/event-category-type-delete-dialog.html',
                    controller: 'EventCategoryTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventCategoryType', function(EventCategoryType) {
                            return EventCategoryType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-category-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
